import { createSlice } from "@reduxjs/toolkit";
import apiAppVersions from "api/app-verisons";
import i18next from "i18next";
import store from "store/store";
import { toastError, toastSuccess } from "utils/helpers";

export const fetchDataVersion = async () => {
    try {
        const res = await apiAppVersions.getAll({ page: store.getState()['managerVersion'].searchQuery.page, size: 5, search: store.getState()['managerVersion'].searchQuery.version })
        store.dispatch(setTableData(res))
    } catch (error) {
        console.log('[Error]: ', error)
    }
}

export const deleteVersion = async ({ id }) => {
    try {
        const res = await apiAppVersions.delete({ id })        

        if(res?.message === "Delete success") {
            toastSuccess(i18next.t('toast.deleteVersionSuccess'))
            const state = store.getState()['managerVersion']
            if(state.tableData.data.length === 1) {
                store.dispatch(setSearchQuery({
                    ...state.searchQuery,
                    page: state.searchQuery.page - 1 || 0
                }))
            } else {
                fetchDataVersion()
            }
        } else {
            toastError(i18next.t('toast.errorDeleteVersion'))
        }
    } catch (error) {
        error.response.data.detail === "version is published" ? toastError(i18next.t('toast.deleteVersionIsPublished')) : toastError(i18next.t('toast.errorDeleteVersion'))
    }
}

export const releaseVersion = async ({ id }) => {
    try {
        const res = await apiAppVersions.release({ id })        

        if(res?.message === "Release success") {
            toastSuccess(i18next.t('toast.releaseVersionSuccess'))
            fetchDataVersion()
        } else {
            toastError(i18next.t('toast.errorReleaseVersion'))
        }
    } catch (error) {
        error.response.data.detail === "version is published" ? toastError(i18next.t('toast.versionIsPublished')) : toastError(i18next.t('toast.errorReleaseVersion'))
    }
}

const initialState = {
    tableData: {
        data: [],
        total: 0
    },
    searchQuery: {
        page: 0,
        version: ''
    },
    isRefresh: false,
    isLoading: false
}

export const managerVersionSlice = createSlice({
    name: 'managerVersion',
    initialState,
    reducers: {
        setTableData: (state, action) => {
            return {
                ...state,
                tableData: action.payload
            }
        },
        setSearchQuery: (state, action) => {
            return {
                ...state,
                searchQuery: {
                    ...state.searchQuery,
                    ...action.payload
                }
            }
        },
        clearSearchQuery: (state) => {
            return {
                ...state,
                searchQuery: {
                    page: 0,
                    version: ''
                }
            }
        }
    }
})

export const { setTableData, setSearchQuery, clearSearchQuery } = managerVersionSlice.actions
export default managerVersionSlice.reducer